export const degreeTitles = [
    'Unknown',
    'Certificate',
    'B.A.',
    'BArch',
    'BFA',
    'B.Sc.',
    'M.A.',
    'M.B.A.',
    'MFA',
    'M.Sc.',
    'J.D.',
    'M.D.',
    'Ph.D',
    'LLB',
    'LLM',
    'Associate',
    'BM'
];



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/EducationList/const.js